import { render, staticRenderFns } from "./aiNewForm.vue?vue&type=template&id=279d88d5&scoped=true&"
import script from "./aiNewForm.vue?vue&type=script&lang=js&"
export * from "./aiNewForm.vue?vue&type=script&lang=js&"
import style0 from "./aiNewForm.vue?vue&type=style&index=0&id=279d88d5&scoped=true&lang=css&"
import style1 from "./aiNewForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d88d5",
  null
  
)

export default component.exports